import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { AddressRepository } from '../repositories/address.repository';
import { NeighborhoodsResponse } from '../models/neighborhoods-response.model';

export class GetNeighborhoodsUseCase
    implements UseCase<number, NeighborhoodsResponse>
{
    constructor(private readonly repository: AddressRepository) {}

    execute(cityId: number): Observable<NeighborhoodsResponse> {
        return this.repository.getNeighborhoods(cityId);
    }
}
